<template>
  <div class="app-container">
    <el-row :gutter="10" align="middle">
      <el-col :span="18">
        <el-form :model="search" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
          <el-form-item label="名称" prop="sName">
            <el-input
                v-model="search"
                placeholder="请输入平台号名称"
                clearable
                @keyup.enter.native="handleQuery"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
<!--      <el-col :span="6" style="text-align: right;">-->
<!--        <el-button-->
<!--            type="success"-->
<!--            icon="el-icon-view"-->
<!--            size="mini"-->
<!--            @click="handleMistake"-->
<!--        >差错详情</el-button>-->
<!--      </el-col>-->
    </el-row>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
            v-if="hasAddPermission"
            type="primary"
            plain
            icon="el-icon-plus"
            size="mini"
            @click="handleAdd"
        >新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
            v-if="hasDelPermission"
            type="danger"
            plain
            icon="el-icon-delete"
            size="mini"
            :disabled="multiple"
            @click="handleDelete2"
        >删除</el-button>
      </el-col>
    </el-row>
    <el-table v-loading="loading" :data="tableList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="案例序号" align="center" prop="accountName" />
      <el-table-column label="刊发平台/平台账号" align="center" prop="platform" />
      <!--      <el-table-column label="出错时间" align="center" prop="time" />-->
      <el-table-column label="案例情况" align="center" prop="mistake" :show-overflow-tooltip="true" />
      <el-table-column label="责任人" align="center" prop="director" />
      <el-table-column label="教训分析" align="center" prop="analysis" :show-overflow-tooltip="true" />
      <el-table-column label="记录时间" align="center" prop="createTime" />
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="text"
              icon="el-icon-view"
              @click="handleDetail(scope.row)"
          >查看详情</el-button>
          <el-button
              v-if="hasUpdatePermission"
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="handleUpdate(scope.row)"
          >修改</el-button>
          <el-button
              v-if="hasDelPermission"
              size="mini"
              type="text"
              icon="el-icon-delete"
              @click="handleDelete(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="title" :visible.sync="open" width="60%" append-to-body>
      <el-row :gutter="15">
        <el-form ref="form" :model="form"
                 :rules="rules"
                 size="medium"
                 label-width="100px">
          <el-col :span="12">
            <el-form-item label="案例序号" prop="name">
              <!--              <el-select v-model="form.accountName" filterable placeholder="请选择">-->
              <!--                <el-option-->
              <!--                    v-for="item in pthOptions"-->
              <!--                    :key="item.id"-->
              <!--                    :label="item.name"-->
              <!--                    :value="item.name">-->
              <!--                </el-option>-->
              <!--              </el-select>-->
              <el-input v-model="form.accountName" placeholder="请输入案例序号" clearable :style="{width: '50%'}">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="刊发平台/平台账号" prop="platform" label-width="150px">
              <el-select v-model="form.platform" filterable placeholder="请选择" allow-create>
                <el-option
                    v-for="item in platformOptions"
                    :key="item.id"
                    :label="item.platform"
                    :value="item.platform">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="案例情况" prop="director">
              <el-input type="textarea" v-model="form.mistake" placeholder="请输入案例情况" clearable :style="{width: '80%'}">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="责任人" prop="director">
              <!--              <el-select v-model="form.director"-->
              <!--                         placeholder="请选择"-->
              <!--                         filterable-->
              <!--                         allow-create-->
              <!--                         default-first-option>-->
              <!--                <el-option-->
              <!--                    v-for="item in directorOptions"-->
              <!--                    :key="item.id"-->
              <!--                    :label="item.name"-->
              <!--                    :value="item.name">-->
              <!--                </el-option>-->
              <!--              </el-select>-->
              <el-input v-model="form.director" placeholder="请输入责任人" clearable :style="{width: '50%'}">
              </el-input>
            </el-form-item>
          </el-col>
          <!--          <el-col :span="12">-->
          <!--            <el-form-item label="出错时间" prop="time">-->
          <!--              <el-date-picker-->
          <!--                  v-model="form.time"-->
          <!--                  type="date"-->
          <!--                  placeholder="选择日期">-->
          <!--              </el-date-picker>-->
          <!--            </el-form-item>-->
          <!--          </el-col>-->

          <el-col :span="24">
            <el-form-item label="教训分析" prop="director">
              <el-input type="textarea" v-model="form.analysis" placeholder="请输入教训分析" clearable :style="{width: '80%'}">
              </el-input>
            </el-form-item>
          </el-col>

        </el-form>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
<!--    <el-dialog title="差错详情" :visible.sync="open2" width="80%" append-to-body>-->
<!--      <Calibration />-->
<!--    </el-dialog>-->
    <el-dialog
        title="详情"
        :visible.sync="open2"
        v-loading="loading"
        width="50%"
    >
      <p class="detail">刊发平台/平台账号：{{detail.platform}}</p>
      <p class="detail">案例情况：{{detail.mistake}}</p>
      <p class="detail">责任人：{{detail.director}}</p>
      <p class="detail">教训分析：{{detail.analysis}}</p>
      <p class="detail">记录时间：{{detail.createTime}}</p>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="open2 = false">确 定</el-button>
          </span>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import axios from "axios";
import {mapState} from "vuex";
import Calibration from "@/views/Calibration.vue";

export default {
  name: "Mistake",
  components: {Calibration},
  data() {
    return {
      // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,

      open: false,
      open2: false,
      title: '',
      // 表格数据
      tableList: [],
      detail:{},
      pthOptions: [],
      directorOptions: [],
      platformOptions: [],

      mistakeData: [],
      // 查询参数
      search: '',
      // 表单参数
      form: {},
    };
  },

  created() {
    this.getList()
    this.getPthName()
    this.getDirector()
    this.getPlatform()
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    hasAddPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_record_add');
    },
    hasDelPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_record_del');
    },
    hasUpdatePermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_record_update');
    },
  },
  methods: {
    // 取消按钮
    cancel() {
      this.open = false;
    },
    getDirector() {
      const type = "账号负责人"
      axios.get(`/api/roster/list/${type}`)
          .then(response => {
            this.directorOptions = response.data;
          })
    },
    getList(){
      this.loading = true;
      request.get('/mistake/getList',{
        params:{
          accountName: this.search
        }
      }).then(res =>{
        this.tableList = res;
        this.loading = false;
      })
    },
    getPthName(){
      request.get('/pth/getAll').then(res =>{
        // console.log(res)
        this.pthOptions = res
      })
    },
    getPlatform() {
      axios.get("/api/platform/getList").then(res => {
        this.platformOptions = res.data
      })
    },
    handleQuery() {
      this.getList()
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    reset() {
      this.form = {
        id: null,
        accountName: null,
        director: null,
        time: null,
        mistake: null,
      };
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加信息";
      this.getPthName();
    },
    handleUpdate(row) {
      const id = row.id || this.ids;
      // 深拷贝避免引用问题
      this.form = JSON.parse(JSON.stringify(row));
      // 回显多选管理员
      // this.form.administrators = row.administrators ? row.administrators.split(', ') : [];
      this.open = true;
      this.title = "修改信息";
    },
    handleDetail(row) {
      this.loading = true;
      this.detail = JSON.parse(JSON.stringify(row));
      this.open2 = true
      this.loading = false
    },
    submitForm() {
      console.log(this.form.id)
      if (this.form.id !== null) {
        request.put('/mistake/update', this.form).then(res => {
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.open = false;
          this.getList();
        });
      } else {
        request.post('/mistake/add', this.form).then(response => {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
          this.open = false;
          this.getList();
        });
      }
    },
    handleDelete(row){
      const ids = row.id;
      this.$confirm('是否确定删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request.delete('/mistake/delete/' + ids).then(res=>{
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getList();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleDelete2() {
      if (this.ids.length === 0) {
        this.$message({
          type: 'info',
          message: '请选择要删除的项'
        });
        return;
      }
      this.$confirm('是否确定删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteBatch(this.ids);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    deleteBatch(ids) {
      request.post('/mistake/deleteBatch', ids)
          .then(res => {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getList(); // 重新获取列表
          })
          .catch(error => {
            console.error(error);
            this.$message({
              type: 'error',
              message: '删除失败'
            });
          });
    },
    getMistakeData() {
      axios.get('https://cloud.dzwww.net//third/dzrb/znjj').then(res => {
        this.mistakeData = res.data;
      });
    },
    handleMistake() {
      this.open2 = true; // 打开对话框
    },
  }
}
</script>

<style scoped>

</style>